<section class="context-lab-page">
  <header class="page-header">
    <div>
      <p class="eyebrow">R&amp;D Lab</p>
      <h1>Hermes Context Agent Lab</h1>
      <p>Test follow-up question resolution before the chatbot calls the existing FAQ getAnswer endpoint.</p>
    </div>
    <span class="status-pill">Isolated test screen</span>
  </header>

  <div class="lab-grid">
    <section class="panel">
      <div class="panel-title">
        <span class="material-icons">history</span>
        <h2>Conversation Context</h2>
      </div>

      <div class="field-grid">
        <label>
          <span>Language</span>
          <select [(ngModel)]="language">
            <option value="ur">Urdu</option>
            <option value="en">English</option>
          </select>
        </label>
        <label>
          <span>Session ID</span>
          <input [(ngModel)]="sessionId" />
        </label>
      </div>

      <div class="history-list" *ngIf="history.length; else emptyHistory">
        <article class="history-card" *ngFor="let turn of history; let i = index">
          <button type="button" class="icon-btn" title="Remove turn" (click)="removeTurn(i)">
            <span class="material-icons">close</span>
          </button>
          <strong>User</strong>
          <p>{{ turn.user }}</p>
          <strong>Assistant</strong>
          <p>{{ turn.assistant }}</p>
          <small *ngIf="turn.resolvedQuestion">Resolved: {{ turn.resolvedQuestion }}</small>
        </article>
      </div>

      <ng-template #emptyHistory>
        <p class="empty-state">No context added yet.</p>
      </ng-template>

      <div class="manual-context">
        <h3>Add Context Turn</h3>
        <textarea rows="2" [(ngModel)]="manualUser" placeholder="Previous user question"></textarea>
        <textarea rows="3" [(ngModel)]="manualAssistant" placeholder="Previous assistant answer"></textarea>
        <div class="button-row">
          <button type="button" class="btn secondary" (click)="addHistoryTurn()">Add Turn</button>
          <button type="button" class="btn ghost" (click)="clearHistory()">Clear</button>
        </div>
      </div>
    </section>

    <section class="panel">
      <div class="panel-title">
        <span class="material-icons">psychology</span>
        <h2>Test Question</h2>
      </div>

      <textarea class="question-box" rows="4" [(ngModel)]="currentQuestion" placeholder="Ask a short follow-up or compound question"></textarea>

      <div class="examples">
        <button type="button" *ngFor="let example of examples" (click)="useExample(example)">
          {{ example }}
        </button>
      </div>

      <button type="button" class="btn primary run-btn" [disabled]="running || !currentQuestion.trim()" (click)="run()">
        <span class="material-icons" [class.spin]="running">{{ running ? 'sync' : 'play_arrow' }}</span>
        {{ running ? 'Testing...' : 'Resolve & Ask FAQ' }}
      </button>

      <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="plan-card" *ngIf="plan">
        <div>
          <span class="label">Mode</span>
          <strong>{{ plan.mode }}</strong>
        </div>
        <div>
          <span class="label">Reason</span>
          <p>{{ plan.reason }}</p>
        </div>
        <div>
          <span class="label">Resolved Question{{ plan.resolvedQuestions.length > 1 ? 's' : '' }}</span>
          <ol>
            <li *ngFor="let q of plan.resolvedQuestions">{{ q }}</li>
          </ol>
        </div>
      </div>

      <div class="result-list" *ngIf="results.length">
        <article class="result-card" *ngFor="let item of results; let i = index">
          <div class="result-head">
            <span>{{ i + 1 }}</span>
            <strong>{{ item.question }}</strong>
          </div>
          <p class="answer">{{ item.answer }}</p>
          <div class="meta-row">
            <span *ngIf="item.matchedQuestion">Matched: {{ item.matchedQuestion }}</span>
            <span *ngIf="item.score !== null && item.score !== undefined">Score: {{ item.score | number:'1.2-2' }}</span>
          </div>
        </article>
      </div>

      <details class="raw-block" *ngIf="rawResponse">
        <summary>Raw getAnswer response</summary>
        <pre>{{ rawResponse }}</pre>
      </details>
    </section>
  </div>
</section>
